var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayMediumPrimaryBudget = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/budget") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/budget"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }), /*#__PURE__*/React.createElement("g", {
    id: "budget",
    transform: "translate(5.000000, 5.000000)",
    fill: "#1B7690",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.30731707,8.08 C-1.48292683,16.42 -0.546341463,28.78 7.41463415,35.95 L19.2682927,21.1 L5.30731707,8.08 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4097561,0.91 C20.3804878,0.91 20.3512195,0.91 20.3219512,0.91 C15.1121951,0.91 10.1073171,3.04 6.4195122,6.85 L20.4097561,19.9 L20.4097561,0.91 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4634146,21.01 L8.70243902,37 C17.3658537,43.57 29.6,41.68 36.0097561,32.8 C38.4682927,29.38 39.8146341,25.24 39.8439024,21.01 L21.4634146,21.01 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0634146,14.32 C31.0634146,13.84 30.9463415,13.48 30.7414634,13.21 C30.5073171,12.94 30.1268293,12.7 29.5707317,12.43 C28.195122,11.86 27.2,11.29 26.5853659,10.72 C25.9707317,10.15 25.6487805,9.31 25.6487805,8.17 C25.6487805,7.15 25.9707317,6.34 26.6439024,5.68 C27.3170732,5.02 28.195122,4.66 29.3073171,4.54 L29.3073171,2.65 L30.6829268,2.65 L30.6829268,4.57 C31.7365854,4.72 32.5560976,5.17 33.1707317,5.89 C33.7853659,6.61 34.0780488,7.54 34.0487805,8.68 L34.0195122,8.71 L31.1219512,8.71 C31.1219512,8.05 31.004878,7.57 30.7414634,7.27 C30.5073171,6.94 30.1853659,6.79 29.7756098,6.79 C29.3658537,6.79 29.0439024,6.91 28.8682927,7.18 C28.6634146,7.45 28.5756098,7.78 28.5756098,8.17 C28.5756098,8.59 28.6926829,8.92 28.897561,9.16 C29.102439,9.43 29.5121951,9.67 30.097561,9.94 C31.4439024,10.54 32.4390244,11.11 33.0829268,11.71 C33.7268293,12.31 34.0487805,13.15 34.0487805,14.23 C34.0487805,15.28 33.7268293,16.09 33.0829268,16.75 C32.4390244,17.38 31.5902439,17.77 30.5073171,17.86 L30.5073171,19.66 L29.1317073,19.66 L29.1317073,17.86 C27.9902439,17.74 27.0536585,17.35 26.3219512,16.66 C25.5902439,15.97 25.2097561,14.95 25.2390244,13.6 L25.2682927,13.54 L28.1365854,13.54 C28.1365854,14.29 28.2829268,14.8 28.604878,15.13 C28.9268293,15.46 29.3365854,15.61 29.8341463,15.61 C30.2439024,15.61 30.5658537,15.49 30.8,15.22 C30.9463415,15.04 31.0634146,14.71 31.0634146,14.32 Z",
    id: "Path"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayMediumPrimaryBudget);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-medium-primary-budget.016017ddab7449719061bb5d6a7297ca.svg";